// extracted by mini-css-extract-plugin
export default {"actions":"PopUpForm_actions__8jc7+"};